import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';
import 'swiper/css';


function HelpAndSupport() {
    const [currentIndex, setCurrentIndex] = useState(1)
    const handleFeatursIndex = (index) => setCurrentIndex(index)

    return (
        <>
            <section className='landing_page_main'>
                <section className='cms_page_top_section'>
                    <div className='page_title_section'>
                        <h1>Help & Support</h1>
                        <div className='breadcrumb_section'>
                            <ul class="breadcrumb">
                                <li><Link to="/">Home</Link></li>
                                <li> Help & Support</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className='cms_content_section'>
                    <div className='container'>
                        <div className='help_support_accordion'>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>How do I set up my account?</Accordion.Header>
                                    <Accordion.Body>
                                    After downloading BYP, create your account using your email address and password. Once logged in, follow the onboarding prompts to enter your pay frequency, next payday, income, savings, expenses, and allowance setup.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header> How do I set up my first budget?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    Simply enter your income and expenses during the onboarding process. The app will automatically calculate and recommend your personal allowance to help manage your finances effectively.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>How do I create a Planned Expense goal?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    Navigate to the "Planned Expenses" section and enter the amount, due date, and other details. The app will calculate how much you need to contribute per paycheck to meet your goal on time.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Can I sync the app with my bank?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    Bank account syncing is not currently available. BYP is designed around the budgeting information you enter directly into the app.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Can I reset my account if I made a mistake?</Accordion.Header>
                                    <Accordion.Body>
                                    Yes. Go to Settings → Reset My Budget to start fresh. Resetting removes your current budget setup, including income, expenses, savings, and paycheck planning, while keeping your BYP account available.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="6">
                                    <Accordion.Header>Why are there different prices for upgrading?</Accordion.Header>
                                    <Accordion.Body>
                                    BYP+ is available through monthly and annual subscription options. The current price and billing period are shown before you confirm your purchase.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="7">
                                    <Accordion.Header>Is my financial data secure?</Accordion.Header>
                                    <Accordion.Body>
                                    Absolutely. Your data is encrypted using industry-standard security protocols, and we do not store sensitive information such as bank passwords.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="8">
                                    <Accordion.Header>What happens to my data if I delete the app?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    Deleting the BYP app from your device does not delete your BYP account or the information associated with it. If you want to delete your account and associated data, use the account-deletion option available within the app.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="9">
                                    <Accordion.Header> How can I contact support?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    You can reach us in the app through Help & Support → Get in touch, or email us at info@bypapp.com.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>

                    </div>
                </section>

                <section id='download-app' className='download_app_section section'>
                    <div className='container'>
                        <div className='download_section'>
                            <div className='download_box'>
                                <h2 className='font-52'>Download from the Apple & Google Play Store</h2>
                                <p className='font-20'>Ready to manage your money between paychecks? Download BYP now from the App Store or Google Play! Whether you’re an iOS or Android user, your journey to financial freedom is just a click away.
                                </p>
                                <div className='download_button_play'>
                                    <a className='app_store_btn' href='https://apps.apple.com/app/id6738954470' target='_blank' rel='noopener noreferrer'><img src="/images/app_store.svg" alt="Download on the App Store" /></a>
<a className='app_store_btn' href='https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share' target='_blank' rel='noopener noreferrer'><img src="/images/google_play.svg" alt="Get it on Google Play" /></a>
                                </div>
                            </div>
                            <div className='download_box_tow'>
                                <div className='image_left_download'>
                                    <img src="/images/byp-download-app-mockup.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contact-us" className="contact_section section">
                    <div className='container'>
                        <div className='contact_content'>
                            <h2 className='font-52'>Contact Us</h2>
                            <p className='font-20'>Have Questions? We’re Here to Help!</p>

                            <div className='contact_form'>
                                <div className='row g-5'>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='First Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Last Name' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Email Address' />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <input type="text" className='contact_input' placeholder='Phone Number' />
                                    </div>
                                    <div className='col-12'>
                                        <textarea id="txtid" name="txtname" rows="4" cols="50" maxlength="200" className='contact_input text_area' placeholder='Write a message'></textarea>
                                    </div>
                                    <div className='col-12'>
                                        <button type='button' className='btn submit_btn'>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default HelpAndSupport;
